/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useState } from "react";
import api from "../utils/api";
import "../utils/apiInterceptor";
import moment from "moment";
import { toast } from "react-toastify";
import unmask from "../utils/unmask";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState("");
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("@ecomlovers:token");
    const userStorage = localStorage.getItem("@ecomlovers:user");

    if (userStorage) {
      setAuthData(JSON.parse(userStorage));
    }
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const signIn = async ({ email, password }) => {
    try {
      const { data } = await api.post(`/talents/authenticate`, {
        email: email.toLowerCase().trim(),
        password: password.trim(),
      });
      const user = data.data.attributes;
      user.id = data.data.id;

      if (user.authToken) {
        // Adding it's token to all requests for now on.
        api.defaults.headers.Authorization = `Bearer ${user.authToken}`;

        localStorage.setItem("@ecomlovers:token", user.authToken);
        localStorage.setItem(
          "@ecomlovers:user",
          JSON.stringify({ ...user, id: data.data.id, type: data.data.type })
        );
        setAuthData({ ...user, id: data.data.id, type: data.data.type });
      } else {
        throw new Error("Token not found");
      }
    } catch (error) {
      //setAuthData("teste");
      throw new Error(error);
    }
  };

  const signInCompanies = async ({ email, password }) => {
    try {
      const { data } = await api.post(`/companies/authenticate`, {
        email: email.toLowerCase().trim(),
        password: password.trim(),
      });

      const user = data.data.attributes;
      user.id = data.data.id;

      if (user.authToken) {
        // Adding it's token to all requests for now on.
        api.defaults.headers.Authorization = `Bearer ${user.authToken}`;
        localStorage.setItem("@ecomlovers:token", user.authToken);
        localStorage.setItem(
          "@ecomlovers:user",
          JSON.stringify({ ...user, id: data.data.id, type: data.data.type })
        );
        setAuthData({ ...user, id: data.data.id, type: data.data.type });
      } else {
        throw new Error("Token not found");
      }
    } catch (error) {
      //setAuthData("teste");
      throw new Error(error);
    }
  };

  const handleAnswer = async (questionOrder, answerText, token) => {
    try {
      if (token) {
        const { data } = await api.post(
          `/talents/knowledge_area/answer_questions`,
          {
            data: {
              attributes: {
                questionOrder: questionOrder,
                answerText: answerText.trim(),
              },
            },
          },
          token && {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return data;
      } else {
        const { data } = await api.post(`/talents/answer_questions`, {
          data: {
            attributes: { questionOrder: questionOrder, answerText: answerText.trim() },
          },
        });
        return data;
      }
    } catch (error) {
      //setAuthData("teste");
      throw new Error(error);
    }
  };

  const handleAnswerKnowledge = async (questionOrder, options, token) => {
    try {
      const { data } = await api.post(
        `/talents/knowledge_area/answer_questions`,
        {
          data: {
            attributes: {
              questionOrder: questionOrder,
              answerOptions: options?.map((item) => ({ id: item })),
            },
          },
        },
        token && {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {
      //setAuthData("teste");
      console.log(error);

      throw new Error(error);
    }
  };

  const handleAnswerAreas = async (questionOrder, options, token) => {
    try {
      const { data } = await api.post(
        `/talents/knowledge_area/answer_questions`,
        {
          data: {
            attributes: {
              questionOrder: questionOrder,
              answerOptions: options?.map((item) => ({
                id: item.id,
                level: item?.level || 0,
              })),
            },
          },
        },
        token && {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {
      //setAuthData("teste");
      console.log(error);

      throw new Error(error);
    }
  };

  const handleAnswerFile = async (questionOrder, answerFile, token) => {
    try {
      if (token) {
        const { data } = await api.post(
          `/talents/knowledge_area/answer_questions`,
          {
            data: {
              attributes: {
                questionOrder: questionOrder,
                avatar: { data: answerFile },
              },
            },
          },
          token && {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return data;
      } else {
        const { data } = await api.post(`/talents/answer_questions`, {
          data: {
            attributes: {
              questionOrder: questionOrder,
              avatar: { data: answerFile },
            },
          },
        });
        return data;
      }
    } catch (error) {
      //setAuthData("teste");
      throw new Error(error);
    }
  };

  const handleQuestion = async () => {
    try {
      const { data } = await api.get(`/questions/questions`);
      return data;
    } catch (error) {
      //setAuthData("teste");
      throw new Error(error);
    }
  };

  const signUp = async (data) => {
    const user = data.attributes;
    user.id = data.id;

    if (user?.authToken) {
      // Adding it's token to all requests for now on.
      api.defaults.headers.Authorization = `Bearer ${user.authToken}`;
      localStorage.setItem("@ecomlovers:token", user.authToken);
      localStorage.setItem(
        "@ecomlovers:user",
        JSON.stringify({ ...user, id: data.id, type: data.type })
      );
      setAuthData({ ...user, id: data.id, type: data.type });
      // toast.success("Cadastro realizado com sucesso!");
      localStorage.setItem("isLoading", "true");
      return "success";
    }
  };

  const updateUser = async (data) => {
    const user = data.data.attributes;
    localStorage.setItem(
      "@ecomlovers:user",
      JSON.stringify({
        ...user,
        id: data.data.id,
        type: data.data.type,
        authToken: authData.authToken,
        expiresAt: authData.expiresAt,
      })
    );
    setAuthData({
      ...user,
      id: data.data.id,
      authToken: authData.authToken,
      expiresAt: authData.expiresAt,
      type: data.data.type,
    });
  };

  const signUpCompany = async (data) => {
    const user = data.data.attributes;

    if (user?.authToken) {
      api.defaults.headers.Authorization = `Bearer ${user.authToken}`;

      localStorage.setItem("@ecomlovers:token", user.authToken);

      localStorage.setItem(
        "@ecomlovers:user",
        JSON.stringify({
          ...user,
          id: data.data.id,
          type: data.data.type
        })
      );

      setAuthData({
        ...user,
        id: data.data.id,
        type: data.data.type
      });

      return "success";
    }

    return "error";
  };

  const completeCompany = async () => {
    const tempStorage = await localStorage.getItem("@ecomlovers:userSignUp");
    api.defaults.headers.Authorization = `Bearer ${tempStorage.authToken}`;
    localStorage.setItem("@ecomlovers:user", tempStorage);
    localStorage.setItem("@ecomlovers:userSignUp", "");
    setAuthData(JSON.parse(tempStorage));

    toast.success("Cadastro realizado com sucesso!");

    return "success";
  };

  const signOutIfTokenExpired = async () => {
    const user = await localStorage.getItem("@ecomlovers:user");
    if (user) {
      const parsedUser = JSON.parse(user);

      if (moment(parsedUser.expiresAt).isBefore(new Date())) {
        signOut();
      } else {
        // Verificar se o token ainda é válido no servidor
        try {
          api.defaults.headers.Authorization = `Bearer ${parsedUser.authToken}`;

          // Verificar token na API correta baseada no tipo de usuário
          if (parsedUser.type === 'talent') {
            await api.get(`/talents/talents/${parsedUser.id}`);
          } else if (parsedUser.type === 'company') {
            await api.get(`/companies/companies/${parsedUser.id}`);
          } else {
            // Para outros tipos ou tipo não definido, tentar companies primeiro (mais comum)
            try {
              await api.get(`/companies/companies/${parsedUser.id}`);
            } catch (companyError) {
              // Se falhar, tentar talents como fallback
              await api.get(`/talents/talents/${parsedUser.id}`);
            }
          }

          setAuthData(parsedUser);
        } catch (error) {
          if (error.response?.status === 401) {
            // Token inválido no servidor, fazer logout
            signOut();
          } else {
            // Se não for erro 401, assumir que está válido
            setAuthData(parsedUser);
          }
        }
      }
    } else {
      signOut();
    }
  };

  useEffect(() => {
    const initializeAuth = async () => {
      await signOutIfTokenExpired();
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const signOut = async () => {
    api.defaults.headers.Authorization = null;
    setAuthData("");
    localStorage.removeItem("@ecomlovers:token");
    localStorage.removeItem("@ecomlovers:user");
  };

  const autoLoginFromUrl = async ({ authToken }) => {
    if (authToken) {
      try {
        const { data } = await api.post("/talents/refresh-token", {}, {
          headers: { Authorization: `Bearer ${authToken}` }
        });

        const user = data.data.attributes;
        user.id = data.data.id;

        if (user.authToken) {
          // Adding it's token to all requests for now on.
          api.defaults.headers.Authorization = `Bearer ${user.authToken}`;

          localStorage.setItem("@ecomlovers:token", user.authToken);
          localStorage.setItem(
            "@ecomlovers:user",
            JSON.stringify({ ...user, id: data.data.id, type: data.data.type })
          );
          setAuthData({ ...user, id: data.data.id, type: data.data.type });
        } else {
          throw new Error("Token not found");
        }
      } catch (error) {
        // if not authorized, clear everything and don't log in
        signOut();
      }
    }
  };

  const autoLoginFromUrlCompanies = async ({ authToken }) => {
    if (authToken) {
      try {
        const { data } = await api.post("/companies/refresh-token", {}, {
          headers: { Authorization: `Bearer ${authToken}` }
        });

        const user = data.data.attributes;
        user.id = data.data.id;

        if (user.authToken) {
          api.defaults.headers.Authorization = `Bearer ${user.authToken}`;

          localStorage.setItem("@ecomlovers:token", user.authToken);
          localStorage.setItem(
            "@ecomlovers:user",
            JSON.stringify({ ...user, id: data.data.id, type: data.data.type })
          );
          setAuthData({ ...user, id: data.data.id, type: data.data.type });
        } else {
          throw new Error("Token not found");
        }
      } catch (error) {
        signOut();
      }
    }
  };

  if (loading) {
    return <></>;
  }

  return (
    <AuthContext.Provider
      value={{
        user: authData,
        loading,
        signUpCompany,
        completeCompany,
        updateUser,
        signIn,
        signInCompanies,
        signOut,
        signUp,
        handleQuestion,
        handleAnswer,
        handleAnswerFile,
        handleAnswerKnowledge,
        handleAnswerAreas,
        isLoading,
        setIsLoading,
        autoLoginFromUrl,
        autoLoginFromUrlCompanies,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
